<div class="aero-dialog-header">

  <button *ngIf="config.closable !== false"
          class="aero-dialog-header-close-icon"
          [attr.aria-label]="closeLabel"
          type="button"
          (click)="this.dialogRef.close()"
          (keydown.enter)="this.dialogRef.close()"
  ><div class="aero-dialog-header-close-hit-box"></div><span class="pi pi-times"></span></button>

  <div class="aero-dialog-header-icon">
    <i *ngIf="config.icon" class="fontawesome-title" [ngClass]="config.icon" aria-hidden="true" [attr.class]="config.iconClass"></i>
    <svg-icon *ngIf="config.svgIconName" [key]="config.svgIconName" [attr.class]="config.iconClass"></svg-icon>
    <span *ngIf="config.headerTemplate"
          [innerHTML]="config.headerTemplate"></span>
  </div>

  <span class="aero-dialog-title">{{ config.title }}</span>

  <span *ngIf="config.detail"
        class="aero-dialog-detail"
        [innerHTML]="config.detail"></span>

</div>

